// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ad13364b","703":"2985fd31"}[chunkId] + ".chunk.js";
};